<template>
  <li class="nav-item">
    <a class="nav-link position-relative" href="/career/chats">
      <span v-if="badge !== false" class="chat-badge">
        {{ badge }}
      </span>
      <img src="@/assets/image/navbar/chat-icon.svg" />
    </a>
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { ChatMessageStatus } from '~/models/career/chatMessageStatus/type';

export default defineComponent({
  components: {},
  props: {
    chatMessageStatus: {
      type: Object as () => ChatMessageStatus,
      required: true
    }
  },

  data() {
    return {};
  },

  computed: {
    // Memo 型はb-avatarのbadge属性の仕様に合わせています
    badge(): boolean | string {
      if (this.chatMessageStatus.unreadCount > 0) {
        return this.chatMessageStatus.unreadCount.toString();
      }
      return false;
    }
  },

  created() {},

  methods: {}
});
</script>

<style scoped>
.chat-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: #df4547;
  color: white;
  font-size: 0.5rem;
  padding: 0.1rem 0.3rem;
  border-radius: 50%;
  margin: 0.5rem;
}
</style>
